module.exports = {"TXTCLI_TelephoneX":{"id":"TXTCLI_TelephoneX","defaultMessage":"Telefon:"}}